export const CURRENT = 'current';
export const FAVORITE = 'favorite';
export const QUANTITY = 'quantity';
export const LOADING_ITEM = 'loadingItem';
export const TIMEOUT_ID = 'timeoutId';
export const DISTRIBUTION = 'distribution';
export const OPEN = 'none';